<template>
  <el-collapse v-if="tableData.length" :value="activeNames">
    <el-collapse-item
      v-for="(item, index) in tableData"
      :key="index"
      :name="index"
      :title="`调度订单编号:${item.dispatchOrderNo}`"
    >
      <SetTempEndTime ref="setTempEndTime" :data="item.children" />
    </el-collapse-item>
  </el-collapse>
</template>
<script>
import XEUtils from 'xe-utils'
import dayjs from '@/libs/util.date.js'
import SetTempEndTime from './temp-endtime.vue'
export default {
  components: { SetTempEndTime },
  props: {
    dispatchOrderNoList: { type: Array, defaul: () => [] },
  },
  data() {
    return {
      tableData: [],
    }
  },
  computed: {
    activeNames() {
      return this.tableData.map((item, index) => index)
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    loadData() {
      this.$api
        .bizWaybillThermometerListBySetEndTimeApi({
          dispatchOrderNoList: this.dispatchOrderNoList,
        })
        .then((res) => {
          this.handleData(res.body.data)
        })
    },
    handleData(data) {
      data = data.map((item) => {
        return {
          ...item,
          endTime: dayjs().format('YYYY-MM-DD HH:mm:ss'),
        }
      })
      this.tableData = this.groupByData(data)
    },
    groupByData(data) {
      const result = []
      XEUtils.each(XEUtils.groupBy(data, 'dispatchOrderNo'), (childs, key) => {
        result.push({
          dispatchOrderNo: key,
          children: childs,
        })
      })
      return result
    },
    async validate() {
      const setTempEndTimes = this.$refs.setTempEndTime || []
      const vas = setTempEndTimes.map((item) => item.validate())

      return await Promise.all(vas).then(
        (res) => res.filter(Boolean).length === 0
      )
    },
    getData() {
      return this.tableData || []
    },
  },
}
</script>
